module.exports = __webpack_public_path__ + "static/trinet-d618189d8deb22cfbd279de849bda3ee.png";